export const ROOT_ID = 'root';
export const MODAL_ID = 'modal';
